import React, { Component } from 'react';
import './App.css';
import Engine from './Components/Engine';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <hh className="App-title">Tic Tac Toe </hh>
          by <a href="https://surajk95.github.io">surajk95</a>
        </header>
        <Engine/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js